var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoomfulLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ffffff;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434,439.6H333.1c-22.3-35-42.5-65.3-60.5-90.8c-18-25.5-37.6-51.8-58.7-78.9h-38.4v118.8 c0,6.2,1,11.6,2.9,16.2c1.9,4.7,6.1,8.2,12.4,10.7c3.2,1.2,8.7,2.4,16.6,3.4c7.9,1.1,14.6,1.7,20.1,1.8v18.7H69.1v-18.7 c4.2-0.4,10.3-1,18.4-1.8c8-0.9,13.6-2,16.8-3.4c5.3-2.3,9.1-5.6,11.5-10c2.4-4.4,3.6-10,3.6-16.9V117.8c0-6.2-0.9-11.6-2.6-16.4 c-1.8-4.8-5.9-8.4-12.4-10.8c-4.4-1.6-10.1-3-17.2-4.4c-7-1.3-13-2.2-18-2.5V65h172.9c15.8,0,30.7,1.6,44.6,4.9 c13.9,3.3,26.5,8.5,37.8,15.7c10.9,7,19.6,16.2,26.1,27.6c6.5,11.4,9.8,25,9.8,41.1c0,14.4-2.2,27.2-6.6,38.3 c-4.4,11.1-10.9,20.7-19.5,28.8c-7.9,7.6-17.4,14.1-28.5,19.7c-11.1,5.5-23.3,10.3-36.7,14.1c18.5,24.5,33.8,45.1,46.1,61.8 c12.2,16.7,27.2,37.1,45,61c7.7,10.6,14.7,18.3,21,23.4c6.2,5,12.5,9.1,18.6,12.3c4.6,2.3,10.3,4.1,17.2,5.3 c6.9,1.2,12.6,1.9,17.2,2.1V439.6z M295.1,160.5c0-22.7-6.5-40.6-19.5-53.9c-13-13.3-31.4-19.9-55.2-19.9h-44.9v160.5h34.6 c24.3,0,44.5-7.8,60.7-23.3C287,208.3,295.1,187.2,295.1,160.5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomfulLogo);
export default __webpack_public_path__ + "static/media/RoomfulLogo.a19f4ac0c939e6491a084bfeba834489.svg";
export { ForwardRef as ReactComponent };